import React from 'react'
import PropTypes from 'prop-types'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

import { settings } from 'parking-react-common'

import { values } from 'lodash'

import classes from 'classnames'

import { ui } from '../redux'

import ErrorMessage from '../components/ErrorMessage'

import '../assets/phone-number-input.css'

const PhoneNumberInput = (props) => {
    const {
        label, input, meta, size, description, ...otherProps
    } = props
    const { name } = input
    const { error } = meta
    return (
        <div className="form-group">
            { label && <label htmlFor={ name }>{ label }</label> }
            <PhoneInput
                id={ name }
                className={ classes('form-control', `input-${size}`) }
                country={ settings.DEFAULT_COUNTRY }
                { ...otherProps }
                { ...input }
            />
            { error && <ErrorMessage error={ error } /> }
            { description && <span className="description">{ description }</span> }
        </div>
    )
}

PhoneNumberInput.propTypes = {
    label       : PropTypes.string,
    input       : PropTypes.object,
    meta        : PropTypes.object,
    description : PropTypes.string,
    size        : PropTypes.oneOf(values(ui.SIZE)),
    isHidden    : PropTypes.bool
}

PhoneNumberInput.defaultProps = {
    size: 'default'
}

export default PhoneNumberInput
